import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Loader,
  Radio,
  RadioGroupField,
  TextField,
  Text,
  PasswordField,
  Grid,
  useTheme,
  View,
  CheckboxField,
  TextAreaField,
  Fieldset,
  SelectField,
  ScrollView,
  Alert,
  Autocomplete,
  Badge,
  BadgeVariations,
  Icon,
  Link,
  Image,
  Card
} from "@aws-amplify/ui-react";
import "./Clienti.css";
import { formConfig, formatValue } from "./config";
import { MdCancel, MdMap, MdStar, MdWhatsapp } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getFileUrl, getRecensoreAPI } from "../../data/api";
import { BsMap } from "react-icons/bs";

const ClienteSchedaFields = (props) => {

  // retrieve signed urls for saved images
  const [imagesUrl, setImagesUrl] = useState({});
  useEffect(() => {
    const fetchImageUrls = async () => {
      const newImagesUrl = {};
      const fetchFieldImageUrl = async (field, value, index?, outerField?) => {
        if (field.type === "UploadField" && value) {
          const signedUrl = await getFileUrl(value);
          newImagesUrl[(outerField ? (outerField+'.') : '')+(index !== undefined ? (index+'.') : '')+field.name] = signedUrl;
        } else if (field.type === "MultiField" && value?.length > 0) {
          for (let i = 0; i < value.length; i++) {
            for (const subField of field.fields) {
              await fetchFieldImageUrl(subField, value[i][subField.name], i, field.name);
            }
          }
        }
      };
      for (const section of formConfig.sections) {
        for (const field of section.fields) {
          const value = props.value[field.name];
          await fetchFieldImageUrl(field, value);
        }
      }
      setImagesUrl(newImagesUrl);
    };
    fetchImageUrls();
  }, [props.value]);

  const renderField = (field, nestedField, index?, outerField?, innerField?) => {
    const value = nestedField == true ? (props.value[outerField]?.[index]?.[innerField]) : props.value[field.name];
    if(field.hidden) return <React.Fragment key={field.name}></React.Fragment>;
        switch (field.type) {
      case "MultiField":
        return <React.Fragment key={field.name}>
          {props.value[field.name]?.length > 0 ? props.value[field.name]?.map((f, index) => {
            return <Card variation="elevated" 
            backgroundColor="var(--amplify-colors-background-secondary)"
            borderRadius="6px" marginBottom="20px" columnSpan={[1,1,1,4]}>
            <Grid 
              templateColumns={{ base: '1fr', large: '1fr 1fr 1fr 1fr' }}
              gap="10px">
            {field?.fields?.map(o => 
              renderField({
                ...o, 
                name: (field.name+'.'+index+'.'+o.name)
              }, true, index, field.name, o.name))
            }
            </Grid>
          </Card>
          }) : "-"}
        </React.Fragment>
        case "UploadField":
          return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <Text><b>{field.label}</b></Text>
            {
              (value == null) ?
              <Text key={value}>
                <i>Nessun file caricato</i>
              </Text>: 
              <Link onClick={() => window.open(imagesUrl[field.name], '_blank')}>
                {imagesUrl[field.name] ? 
                <Image src={imagesUrl[field.name] ?? ''} alt={field.name ?? ''} maxWidth="300px" maxHeight="300px"/> :
                <Loader></Loader>}
              </Link>
          }
          </View>
          );
      default:
        return (
          <View columnSpan={field.columnSpan} key={field.name}>
            <Text><b>{field.label}</b></Text>
            <Text>{(value !== '' ? formatValue(value, field.name) : '-') ?? '-'} 
              {field.dataType === 'phone' && value !== null && value !== '' && <Icon 
                as={MdWhatsapp} 
                marginLeft={"5px"}
                marginBottom={"4px"}
                onClick={() => window.open('https://wa.me/'+value, '_blank')} 
                style={{"cursor":"pointer"}}>
              </Icon>}
              {field.dataType === 'address' && value !== null && value !== '' && <Icon 
                as={MdMap} 
                marginLeft={"5px"}
                marginBottom={"4px"}
                onClick={() => window.open(`${"https://www.google.com/maps/search/?api=1&query="}${encodeURIComponent(
                  field.getAddressString(props.value) ?? value
                )}`, '_blank')} 
                style={{"cursor":"pointer"}}>
              </Icon>}
            </Text>
          </View>
        );
    }
  };

  return (
    <Grid 
      templateColumns={{ base: '1fr', large: '1fr 1fr 1fr 1fr' }}
      gap="10px">
      {formConfig.sections.map((section, sectionIndex) => (
        <React.Fragment key={section.title}>
          <View columnSpan={[1, 1, 1, 4]}><h4>{section.title}</h4></View>
          {section.fields.filter(f => f.isVisible !== undefined ? f.isVisible(props.value) : true).map(o => renderField(o, false))}
          <View columnSpan={[1, 1, 1, 4]}></View>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default ClienteSchedaFields;
